module.exports = __webpack_public_path__ + "static/forecast/fresh-snow/ankle-ba7eebccd6d62409913dcac132b0c30d.svg";